import { create } from 'zustand'

interface CfgFilterState {
  formSaved: boolean
  setFormSaved: (saved: boolean) => void
}

const useCfgFilterStore = create<CfgFilterState>((set) => ({
  formSaved: false,
  setFormSaved: (saved) => set({ formSaved: saved }),
}))

export default useCfgFilterStore
